import React, { useState, useEffect } from 'react'

import Link from './Link'
// import Logo from '../assets/images/logo/new-logo.png'
// import Logo from '../assets/images/logo/new-logo-2024.png'
import Logo from '../assets/images/logo/logo-transparent-2026.png'


import { stack as Menu } from 'react-burger-menu'
import { useScreen } from '../lib/hooks'

const Navbar = ( { path } ) => {
    const [ windowWidth, setWindowWidth ] = useState( typeof window !== 'undefined' ? window.screen.width : 1920 )
    const [ navHidden, setNavHidden ] = useState( true )
    const handleResize = () => setWindowWidth( typeof window !== 'undefined'  ? window.innerWidth : 1920 )
    const [ navStyle, setNavStyle ] = useState( { zIndex: 1000 } )
    const [ dropdownStyle, setDropdownStyle ] = useState( { } )

    const [ scrollPos, setScrollPos ] = useState( typeof window !== 'undefined' ? window.pageYOffset : 0 )
    const [ burgerMenuOpen, setBurgerMenuOpen ] = useState( false )
    const isMobile = useScreen( 1120 )

    const transparentNavStyle = { 
        // backgroundColor: 'rgba(0, 37, 100, 0.7)',
        backgroundColor: path === '/' ? 'rgba(255, 255, 255, 0.8)' :'rgba(255, 255, 255, 0.8)',

        color: 'black',
        position: 'absolute',
        width: '100%',
        zIndex: 1000,
        transition: '10ms',
        fontWeight: path === '/' ? '800' : '400 !important'
    } 

    const hideNav = () => {
        setNavHidden( true )
        setBurgerMenuOpen( false )
        let element = document.getElementsByClassName( "bm-overlay" )[0]
        element.click()
        // console.log( burgerMenuOpen )
    }


    useEffect( () => {
        if( typeof window !== 'undefined' ){
            window.addEventListener( 'resize', handleResize  )
            handleResize()
            window.addEventListener( 'scroll', () => setScrollPos( window.pageYOffset )  )

    
            return window.removeEventListener( 'resize', handleResize )
        }
        setNavStyle( transparentNavStyle )
        setDropdownStyle( { backgroundColor: 'rgba(0, 37, 100, 0.95)' } )

       
    }, [] )

    useEffect( () => {

        // console.log(path.replaceAll('/', ''))
        let paths = [ 'calendar', 'lifegroups', 'our-team', 'mediaaudio*', 'mediavideos*' ]
        const normalisedPath = path.replaceAll( '/', '' )
        if ( paths.includes( normalisedPath ) ) {
            setNavStyle( { 
                zIndex: 1000, 
                backgroundColor: 'rgba(255,255,255,1)',
                transition: '200ms', 
                position: 'relative', 
                width: '100%'
            } )
            setDropdownStyle( { backgroundColor: 'rgba(249,249,249,1)' } )
        } else if ( [ 'giving', 'missions' ].includes( normalisedPath ) ) {
            setNavStyle( { 
                backgroundColor: 'rgba(0, 37, 100, 0.85)',
                color: 'white',
                position: 'absolute',
                width: '100%',
                zIndex: 1000,
                transition: '10ms'
            } )
            setDropdownStyle( { backgroundColor: 'rgba(0, 37, 100, 0.95)' } )

        } else {
            // setNavStyle( { backgroundColor: 'rgba(255,255,255,1)', zIndex: 1000 } )
            setNavStyle( transparentNavStyle )
            // setDropdownStyle( { backgroundColor: 'rgba(0,0,0,0.95)'})
            // setDropdownStyle( { backgroundColor: 'rgba(0, 37, 100, 0.95)'})
            setDropdownStyle( { backgroundColor: 'rgba(249,249,249,1)' } )


        }

    }, [ path ] )


    // useEffect( () => {
    //     // console.log(  scrollPos  )
    //     if ( scrollPos > 0 ) {
    //         setNavStyle( { zIndex: 1000,  backgroundColor: 'rgba(255,255,255,1)', transition: '200ms', position: 'sticky', width: '100%'} )
    //         setNavStyle( { 
    //             backgroundColor: 'rgba(0,0,0,0.5)',
    //             color: 'white',
    //             position: 'absolute',
    //             width: '100%',
    //             zIndex: 1000,
    //             transition: '10ms'
    //         } )
    //     } else {
    //         // setNavStyle( { backgroundColor: 'rgba(255,255,255,1)', zIndex: 1000 } )
    //         setNavStyle( { 
    //             backgroundColor: 'rgba(0,0,0,0.5)',
    //             color: 'white',
    //             position: 'absolute',
    //             width: '100%',
    //             zIndex: 1000,
    //             transition: '10ms'
    //         } )

            

    //     }

    // }, [ scrollPos ] )

    const links = [
        { text: "Home", url: "/" },
        { text: "About Us", url: "#", submenu: [
            { text: "Who We Are", url: "/about-us" },
            { text: "Our Team", url: "/our-team" },
        ] },
        { text: "Services & Media", url: "#", submenu: [
            { text: "Services", url:"/services" },
            { text: "Video Sermons", url:"/media/videos" },
            { text: "Prayer Audios", url:"/media/audio" }
        ]  },
        { text: "What's On", url:"#", submenu: [
            { text: "Upcoming", url: "/whats-on#upcoming" },
            { text: "Calendar", url: "/calendar" },
        ]  },
        { text: "Church Life", url:"/church-life" },
        { text: "Serving", url:"/serving" },
        { text: "Mission", url:"/missions" },
        { text: "Giving", url:"/giving" },
        { text: "Contact", url:"#", submenu: [
            { text: "Reach Us", url:"/contact" },
            { text: "Hall Hire", url:"/hall-for-hire" },
            { text: "Jobs", url:"/jobs" }
        ] },
        
    ]

    const urlMatch = ( url ) => {
        // const urlSplit =  url.slice( url.length - 1 ) === "/" ?  url.slice( 0, -1 ).split( '/' ) : url.split( "/" )
        const urlSplit = url.split( "/" )
        let locationUrlSplit = [] 
        if( typeof window !=='undefined' ) {
            const currentPath = window.location.href
            locationUrlSplit = currentPath.slice( currentPath.length - 1 ) === "/" ?  currentPath.slice( 0, -1 ).split( '/' ) : currentPath.split( "/" )
        }

        if ( urlSplit[1] === "" )
            return locationUrlSplit.length === 3
        
        let fullUrlMatch = urlSplit.slice( 1 ).length > 0 && urlSplit.slice( 1 ).every( val => locationUrlSplit.includes( val ) )
        
        return fullUrlMatch && locationUrlSplit[ locationUrlSplit.length - 1 ] !== ""
    }

    const setActiveUrl = ( url, submenu = [] ) => {
        if( urlMatch( url ) )
            return " active"
        else if( submenu.reduce( ( prev, cur, i ) => prev || urlMatch( cur.url ), false ) ) 
            return " active"
        else
            return ""
    }

    const logoSize = 90
    const logoStyle = { 
        position: 'absolute', 
        left: '5%', 
        top: 5, 
        float: 'left',
        transform: 'scale(0.85)'
    }
    const logoStyleMobile = { 
        ...logoStyle,
        left: 25,
        top: 2,
        transform: 'scale(0.5)',

    }

    return isMobile ? (
        <div className="navbar" style={navStyle}>
                {/* <div className="navbar-menu-button" onClick={() => setNavHidden( !navHidden )}><Collapse active={!navHidden}/></div> */}
                <Link to='/'><img src={Logo} width={logoSize} height={logoSize} style={logoStyleMobile} /></Link>

                <Menu width='100%' isOpen={burgerMenuOpen}>
                    { links.map( ( { text, url, submenu = [] } ) =>
                                <>
                                <div className={`navbar-link menu-item${setActiveUrl( url )}`} style={{ paddingBottom: '2px' }} key={url}><Link onClick={() => hideNav()} to={url}>{text}{submenu.length > 0 && <span style={{ fontSize: '0.6em' }}>&nbsp;&nbsp;{String.fromCodePoint( '0x25BC' )}</span>}</Link></div>
                                {submenu.length > 0 && submenu.map( ( { text, url } ) => (
                                    <div className={`navbar-link menu-item${setActiveUrl( url )} mobile-submenu`} key={url}><Link onClick={() => hideNav()} to={url}>{text}</Link></div> 
                                ) )}
                                </>
                        )
                    }
                        
                    {/* <div className='navbar-link'><AniLink fade duration={0.4} to="/login" className="fa fa-user-circle-o" style={{ border: "none" }}></Link></div> */}
                </Menu>
        </div>
    ) :

    (
        <div className="navbar" style={navStyle}>
            <Link to='/'><img src={Logo} width={logoSize} height={logoSize} style={logoStyle} /></Link>
            { links.map( ( { text, url, submenu = [] } ) => 
                <span className='navbar-dropdown'>
                    <Link className={`navbar-link menu-item${setActiveUrl( url, submenu )}`} key={url} to={url}>{text}{submenu.length > 0 && <span style={{ fontSize: '0.6em' }}>&nbsp;&nbsp;{String.fromCodePoint( '0x25BC' )}</span>}</Link>
                    {submenu.length > 0 && (
                        <div className='dropdown-content' style={dropdownStyle}>
                        {submenu.map( ( { text, url } ) => 
                                                                <Link className={`navbar-link menu-item${setActiveUrl( url )}`} key={url} to={url}>{text}</Link>
                        )}
                        </div>
                    )}
                </span> )}
            {/* <div className='navbar-link'><AniLink paintDrip hex="#ffffff" duration={0.6} to="/login" className="fa fa-user-circle-o" style={{ border: "none" }}></AniLink></div> */}
        </div>
    )

}


export default Navbar
